import {cloneDeep} from "lodash";
import {SET_MODAL_VISIBILITY} from "./constants";
import {SetModalVisibilityActions, SetModalVisibilityState} from "./types";

const initialState: SetModalVisibilityState = {
  data: [],
}

const reducer = (
  state = initialState,
  action: SetModalVisibilityActions,
): SetModalVisibilityState => {
  switch (action.type) {
    case SET_MODAL_VISIBILITY:
      let updatedData = cloneDeep(state.data);
      if (action.payload.isVisible) {
        if (!updatedData.includes(action.payload.modal)) {
          updatedData.push(action.payload.modal);
        }
      } else {
        updatedData = updatedData.filter(e => e !== action.payload.modal);
      }
      return {
        ...state,
        data: [...updatedData],
      }
    default:
      return state;
  }
}

export default reducer;
